const ApartmentAmenity = ({ amenity = '', availableInSelectUnits = false, id = '', isEditable = false } = {}) => ({
  amenity: String(amenity),
  availableInSelectUnits: Boolean(availableInSelectUnits),
  id: String(id),
  isEditable: Boolean(isEditable),
});

export default ApartmentAmenity;

export type ApartmentAmenityProps = ReturnType<typeof ApartmentAmenity>;
